import { addFavorite, deleteFavorite } from '../../../../shared/common/actions/favorites';
import { TThunkDispatch } from '../../../../shared/common/types/redux';
import { callAuthenticationPopup } from '../../../../shared/common/utils/authentication';
import { EAddFavoritesActionTypes, EDeleteFavoritesActionTypes } from '../actions/favorites';
import { ERequestAuthenticationActionType } from '../actions/requestAuthentication';
import { IReduxActionMessage } from '../types';

export function reduxActionMessageHandler(message: IReduxActionMessage, dispatch: TThunkDispatch) {
  switch (message.value.type) {
    case EDeleteFavoritesActionTypes.Failure:
    case EAddFavoritesActionTypes.Request:
      dispatch(addFavorite(message.value.payload.offerId));
      break;
    case EDeleteFavoritesActionTypes.Request:
    case EAddFavoritesActionTypes.Failure:
      dispatch(deleteFavorite(message.value.payload.offerId));
      break;
    case ERequestAuthenticationActionType.Modal:
      callAuthenticationPopup(message.value.payload);
      break;
  }
}
